import React, { Component } from 'react'
import SalarySlider from 'components/SalarySlider'
import { SalaryList } from 'components/List'

import './styles.scss'

export class Dashboard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      val: 6502
    }
  }

  handleSliderChange = value => {
    this.setState({ val: value })
  }

  handleTrackSliderChange(target) {
    const clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'slider',
      event_label: 'value: ' + clickedText
    })
  }

  render() {
    const digitFormat = new Intl.NumberFormat('de-CH', {
      style: 'decimal',
      minimumFractionDigits: 0
    }).format

    return (
      <div>
        <div className='salarySliderWrapper'>
          <div className='salaryValueTitle'>
            <span>Ihr Monatsgehalt</span> (brutto):
          </div>
          <div className='salaryValue'>
            {digitFormat(this.state.val)} <span>in Fr.</span>
          </div>
          <div className='salaryValueByline'>
            Jahreslohn auf 100% geteilt durch 12, ohne Bonus und Gratifikation
          </div>
        </div>
        <SalarySlider
          onChange={this.handleSliderChange}
          onAfterChange={this.handleTrackSliderChange}
          sliderValue={this.state.val}
        />
        <div className='contentWrapper' style={{ marginTop: '3rem' }}>
          <div className='arrowText'>
            Sie müssen für das Gehalt der anderen so lange arbeiten
          </div>
          <div className='arrowWrapper'>
            <img
              src={require('../imgs/icon_arrow.svg')}
              className='yourSalaryIcon'
              alt='yourSalary Icon'
            />
          </div>
        </div>
        <div>
          <SalaryList
            sliderValue={this.state.val}
            articleId={this.props.articleId}
          />
        </div>
      </div>
    )
  }
}
